import React, {useState, useEffect} from 'react'
import "./Stuff.scss"
import { NavLink } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleLeft } from '@fortawesome/free-solid-svg-icons'
import Useless from './LeftCaract/Useless'
import Elementaire from './LeftCaract/Elementaire'
import General from './LeftCaract/General'
import Resistance from './LeftCaract/Resistance'
import Center from './Center/Center'
import Right from './Right/Right'
import {fetchData} from './Right/ApiFetch';


export default function Stuff() {
    const [annoImage, setAnnoImage] = useState(null);
    const [hatImage, setHatImage] = useState(null);
    const [amuImage, setAmuImage] = useState(null);
    const [cloakImage, setCloakImage] = useState(null);
    const [swordImage, setSwordImage] = useState(null);
    const [anno2Image, setAnno2Image] = useState(null);
    const [bootsImage, setBootsImage] = useState(null);
    const [beltImage, setBeltImage] = useState(null);
    
    const [fetchTriggered, setFetchTriggered] = useState(false);
    
    const [apiData, setApiData] = useState([]);
    const [apiDataCaract, setApiDataCaract] = useState([]);

    const [minLvl, setMinLvl] = useState(200);
    const [maxLvl, setMaxLvl] = useState(200);
    
    const handleFetchData =  (minLvl, maxLvl, itemType) => {
        fetchData(setApiData, setApiDataCaract, minLvl, maxLvl,itemType);
    };

    useEffect(() => {
        if (fetchTriggered) {
            handleFetchData(minLvl, maxLvl);
            setFetchTriggered(false);
        }
    }, [minLvl, maxLvl, fetchTriggered]);

    const handleMinLvlChange = (event) => {
        const newMinLvl = parseInt(event.target.value, 10);
        setMinLvl(newMinLvl);
        handleFetchData(newMinLvl, maxLvl);
    };
    
    const handleMaxLvlChange = (event) => {
        const newMaxLvl = parseInt(event.target.value, 10);
        setMaxLvl(newMaxLvl);
        handleFetchData(minLvl, newMaxLvl);
    };

    const handleClick = () => {
        setFetchTriggered(true);
    };

    const handleItemSelection = (item) => {
        setAnnoImage(item);
    };
    const handleHatSelection = (item) => {
        setHatImage(item);
    };
    const handleAmuSelection = (item) => {
        setAmuImage(item);
    };
    const handleCloakSelection = (item) => {
        setCloakImage(item);
    };
    const handleSwordSelection = (item) => {
        setSwordImage(item);
    };
    const handleAnno2Selection = (item) => {
        setAnno2Image(item);
    };
    const handleBeltSelection = (item) => {
        setBeltImage(item);
    };
    const handleBootsSelection = (item) => {
        setBootsImage(item);
    };
    
    return (
        <div className='stuff__wrapper'>
            <div className="stuff__container">
                <div className='stuff__info__container'>
                    <NavLink to="/">
                        <div className="btnRetour stuff__box">
                            <i>
                                <FontAwesomeIcon icon={faAngleLeft} />
                            </i>
                        </div>
                    </NavLink>
                    <div className="stuff__box stuff__info">
                        <div className='stuff__input__wrapper'>
                            <label for="stuffName">Nom du stuff</label>
                            <input type="text" id='stuffName' className="name" />
                        </div>
                    </div>
                </div>
                <div className="stuff__box stuff__left">
                    <div className="stuff__left__container">
                        <div className="general__stats stats__test">
                            <General 
                            item={annoImage}
                            hatImage = {hatImage}
                            amuImage={amuImage}
                            cloakImage={cloakImage}
                            swordImage={swordImage}
                            anno2Image={anno2Image}
                            beltImage={beltImage}
                            bootsImage={bootsImage}
                            />
                        </div>
                        <div className="elem__stats stats__test">
                            < Elementaire 
                            item={annoImage} 
                            hatImage = {hatImage}
                            amuImage={amuImage}
                            cloakImage={cloakImage}
                            swordImage={swordImage}
                            anno2Image={anno2Image}
                            beltImage={beltImage}
                            bootsImage={bootsImage}
                            />
                        </div>
                        <div className="resistance stats__test">
                            < Resistance 
                            item={annoImage}
                            hatImage = {hatImage}
                            amuImage={amuImage}
                            cloakImage={cloakImage}
                            swordImage={swordImage}
                            anno2Image={anno2Image}
                            beltImage={beltImage}
                            bootsImage={bootsImage}
                            />
                        </div>
                        <div className="useless__stats stats__test">
                            < Useless 
                            item={annoImage}
                            hatImage = {hatImage}
                            amuImage={amuImage}
                            cloakImage={cloakImage}
                            swordImage={swordImage}
                            anno2Image={anno2Image}
                            beltImage={beltImage}
                            bootsImage={bootsImage}
                            />
                        </div>
                    </div>      
                </div>
                <div className="stuff__box stuff__center">
                    <Center 
                    onFetchData={handleFetchData} 
                    onClickAnno1={handleClick} 
                    minLvl = {minLvl}
                    maxLvl = {maxLvl}
                    annoImage={annoImage}
                    hatImage={hatImage}
                    amuImage={amuImage}
                    cloakImage={cloakImage}
                    swordImage={swordImage}
                    anno2Image={anno2Image}
                    beltImage={beltImage}
                    bootsImage={bootsImage}
                    onItemSelected={handleItemSelection}
                    onHatSelected={handleHatSelection} 
                    onAmuSelected={handleAmuSelection} 
                    onCloakSelected={handleCloakSelection} 
                    onSwordSelected={handleSwordSelection} 
                    onAnno2Selected={handleAnno2Selection}
                    onBeltSelected={handleBeltSelection}
                    onBootsSelected={handleBootsSelection}
                    />
                </div>
                <div className="stuff__box stuff__right">
                    <Right 
                    apiData={apiData} 
                    apiDataCaract={apiDataCaract} 
                    minLvl={minLvl}
                    handleMinLvlChange={handleMinLvlChange}
                    maxLvl={maxLvl}
                    handleMaxLvlChange={handleMaxLvlChange}
                    setMinLvl={setMinLvl}
                    setMaxLvl={setMaxLvl}
                    annoImage={annoImage}
                    onItemSelected={handleItemSelection}
                    onHatSelected={handleHatSelection}
                    onAmuSelected={handleAmuSelection}
                    onCloakSelected={handleCloakSelection} 
                    onSwordSelected={handleSwordSelection} 
                    onAnno2Selected={handleAnno2Selection} 
                    onBeltSelected={handleBeltSelection} 
                    onBootsSelected={handleBootsSelection} 
                    />
                </div>
            </div>
        </div>
    )
}
